<template>
    <el-dialog :title="$t('searchPicture')" width="35%" :visible.sync="visible">
        <div class="upload-way">
            <el-upload drag :before-upload="beforeUpload" :show-file-list="false">
                <div class="way box_1">
                    <div>
                        <el-button icon="upload" type="primary">{{ $t('choosePicture') }}</el-button>
                        <div class="way1_tips">{{ $t('clickOrDrag') }}</div>
                    </div>
                </div>
            </el-upload>
            <div class="way box_2" ref="imageUploadDiv" @paste="handlePaste($event)">
                <div class="way2_tips" v-if="copyImg == null">
                    <input @pause="handlePaste" class="imageInput" type="text" />{{ $t('copyPicture') }}
                </div>
                <img v-else :src="copyImg" alt="" srcset="" class="imgs" />
            </div>
        </div>
        <div class="cropper_box">
            <div class="cropper" v-if="options.img !== ''">
                <vue-cropper ref="cropper" id="pasteImg" :img="options.img" :info="options.info"
                    :outputSize="options.outputSize" :outputType="options.outputType" :canMove="options.canMove"
                    :autoCrop="options.autoCrop" :full="options.full" :autoCropWidth="options.autoCropWidth"
                    :autoCropHeight="options.autoCropHeight" :fixedBox="options.fixedBox" :original="options.original"
                    :infoTrue="options.infoTrue" :centerBox="options.centerBox" :canMoveBox="options.canMoveBox"
                    :canScale="options.canScale" :fixed="options.fixed" :fixedNumber="options.fixedNumber"
                    :enlarge="options.enlarge" @realTime="realTime">
                </vue-cropper>
            </div>
            <div class="cropper preview_box" v-else>
                <div>{{ $t('pictureCrop') }}</div>
            </div>
        </div>
        <div class="actionList">
            <el-button @click="deleteImg">{{ $t('delete') }}{{ $t('picture') }}</el-button>
            <el-button icon="el-icon-plus" @click="changeScale(1)"></el-button>
            <el-button icon="el-icon-minus" @click="changeScale(-1)"></el-button>
            <el-button icon="el-icon-refresh-left" @click="rotateLeft"></el-button>
            <el-button icon="el-icon-refresh-left" @click="rotateRight"></el-button>
        </div>
        <template slot="footer">
            <el-button key="back" @click="cancelHandel">
                {{ $t('cancel') }}
            </el-button>
            <el-button key="submit" type="primary" :loading="uploading" @click="finish('blob')">
                {{ $t('confirm') }}
            </el-button>
        </template>
    </el-dialog>
</template>
<script>
import { searchPicture } from "@/api/product"
import { mapGetters } from 'vuex'
const uidGenerator = () => {
    return '-' + parseInt(Math.random() * 10000 + 1, 10)
}
export default {
    name: 'searchPic',
    pros: {
        imgUrl: {
            type: String,
            default: () => ''
        }
    },
    data() {
        return {
            visible: false,
            confirmLoading: false,
            fileList: [],
            uploading: false,
            copyImg: null,
            options: {
                img: '',
                outputSize: 1, // 裁剪生成图片的质量 0.1 - 1
                outputType: 'png', //	裁剪生成图片的格式 jpeg || png || webp
                canScale: true, // 图片是否允许滚轮缩放 默认true
                autoCrop: true, // 是否默认生成截图框 默认false
                canMove: true, // 上传图片是否可以移动 默认true
                autoCropWidth: 200, // 默认生成截图框宽度	容器的80%	0~max
                autoCropHeight: 200, // 默认生成截图框高度	容器的80%	0~max
                fixedBox: false, // 固定截图框大小 不允许改变	false	true | false
                fixed: false, // 是否开启截图框宽高固定比例
                full: false,
                original: false, // 上传图片按照原始比例渲染	false	true | false
                infoTrue: false, // 为展示真实输出图片宽高 false 展示看到的截图框宽高	false	true | false
                centerBox: true, // 截图框是否被限制在图片里面	false	true | false
                canMoveBox: true, // 截图框能否拖动	true	true | false
                fixedNumber: [1, 1], // 截图框的宽高比例 [宽度, 高度]
                enlarge: 1
            },
            previews: {},
            previewStyle1: {},
            copyImgStatues: false
        }
    },
    computed: {
        ...mapGetters('user', {
            userInfo: 'get_userInfo'
        })
    },
    methods: {
        // 打开图片搜索框
        openDialog() {
            this.visible = true
        },
        // 删除图片
        deleteImg() {
            this.options.img = ''
            this.copyImg = null
        },
        // 粘贴图片
        handlePaste(event) {
            const items = event.clipboardData && event.clipboardData.items
            let file = null

            if (items && items.length) {
                for (var i = 0; i < items.length; i++) {
                    if (items[i].type.indexOf('image') !== -1) {
                        file = items[i].getAsFile()
                    }
                }
            }

            if (!file) {
                this.$message.error(this.$t('notImage'))
                return
            }

            this.copyImgStatues = true
            file.uid = uidGenerator()
            this.beforeUpload(file)
        },
        // 取消
        cancelHandel() {
            this.visible = false
        },
        // 改变大小
        changeScale(num) {
            num = num || 1
            this.$refs.cropper.changeScale(num)
        },
        // 左旋转
        rotateLeft() {
            this.$refs.cropper.rotateLeft()
        },
        // 右旋转
        rotateRight() {
            this.$refs.cropper.rotateRight()
        },
        beforeUpload(file) {
            this.fileList = file
            const reader = new FileReader()
            // 把Array Buffer转化为blob 如果是base64不需要
            // 转化为base64
            reader.readAsDataURL(file)
            reader.onload = () => {
                const img = new Image()
                img.src = reader.result
                this.options.img = reader.result
                this.copyImg = null
                if (this.copyImgStatues) {
                    this.copyImg = reader.result
                }
                img.onload = () => {
                    this.options.autoCropWidth = img.width
                    this.options.autoCropHeight = img.height
                    this.copyImgStatues = false
                }
            }
            return false
        },
        // 上传图片（点击上传按钮）
        finish(type) {
            if (!this.options.img) return
            if (type === 'blob') {
                this.uploading = true
                this.$refs.cropper.getCropBlob(data => {
                    if (!data) return
                    const files = new window.File([data], this.fileList.name, { type: this.fileList.type })
                    const formData = new FormData()
                    formData.append('file', files)
                    formData.append('client_Nu', this.userInfo.client_Nu || '')
                    searchPicture(formData)
                        .then(res => {
                            if (res.success) {
                                if (res.data.length < 1) {
                                    this.uploading = false
                                    this.$message.error('暂未匹配到数据')
                                } else {
                                    this.$emit('ok', res)
                                    this.visible = false
                                    this.uploading = false
                                }
                            } else {
                                this.uploading = false
                                this.$message.error(res.message)
                            }
                        })
                        .catch(err => {
                            this.$message.error(err.message)
                            this.visible = false
                        })
                })
            } else {
                this.$refs.cropper.getCropData(data => { console.log(data); })
            }
        },
        realTime(data) {
            this.previews = data
            this.previewStyle1 = {
                width: data.w + 'px',
                height: data.h + 'px',
                overflow: 'hidden',
                margin: '0',
                zoom: 1
            }
        }
    }
}
</script>
<style lang="scss" scoped>

</style>